import type { MultipleEditDrawerLineItemsFormValues } from '../../../../../../types';

type BufferConflict = {
  lineItemIdsWithFlexibleBuffer: string[];
  lineItemIdsWithFlexibleFrontload: string[];
};

export type BufferConflictIdsResult = {
  bufferConflictIds: string[];
  frontloadConflictIds: string[];
};

type Props = {
  values: MultipleEditDrawerLineItemsFormValues;
};

export const checkBufferConflicts = ({ values }: Props): BufferConflictIdsResult => {
  const defaultBufferConflicts = {
    bufferConflictIds: [],
    frontloadConflictIds: [],
  };

  const isBufferSelected = values.selectedSections.includes('Buffer');
  const isFrontloadSelected = values.selectedSections.includes('Frontload');

  if (!isBufferSelected && !isFrontloadSelected) {
    return defaultBufferConflicts;
  }

  const lineItemIdsWithFlexibleBuffer = values.initialStatuses.reduce<BufferConflict>(
    (acc, entity) => {
      if (entity.buffer?.deliveryBufferPercent != null) {
        acc.lineItemIdsWithFlexibleBuffer.push(entity.id);
      }

      if (entity.buffer?.frontLoadPercent != null) {
        acc.lineItemIdsWithFlexibleFrontload.push(entity.id);
      }

      return acc;
    },
    { lineItemIdsWithFlexibleBuffer: [], lineItemIdsWithFlexibleFrontload: [] }
  );

  return values.entities
    .filter((entity) => entity.isSelected)
    .reduce<BufferConflictIdsResult>((acc, entity) => {
      const hasBufferConflict =
        isBufferSelected &&
        values.buffer.deliveryBufferPercent != null &&
        !lineItemIdsWithFlexibleBuffer.lineItemIdsWithFlexibleBuffer.includes(entity.id);

      const hasFrontloadConflict =
        isFrontloadSelected &&
        values.buffer.frontLoadPercent != null &&
        !lineItemIdsWithFlexibleBuffer.lineItemIdsWithFlexibleFrontload.includes(entity.id);

      if (hasBufferConflict) {
        acc.bufferConflictIds.push(entity.id);
      }

      if (hasFrontloadConflict) {
        acc.frontloadConflictIds.push(entity.id);
      }

      return acc;
    }, defaultBufferConflicts);
};
